import { ChangeDetectionStrategy, Component, ChangeDetectorRef } from '@angular/core';
import { UrlBuilder } from '../../core';
import { GridHeader, GridDetails, ActionType } from '../../sample-tracking/tracking-overview/interfaces/grid';
import { merge } from 'lodash';
import { of, Subscription, Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { SamplesInfo } from './interface/sample-info';
import { ActivityLogger } from '../../activities/activity-logger';
import { SampleDetailsService } from './service/sample-details-service';

@Component({
    selector: 'pending-registration',
    template: require('./sample-details.component.html'),
    styles: [require('./sample-details.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PendingSampleRegistrationComponent {

    public label = 'Pending Registration';
    public gridDetails: GridDetails;
    public isLoadingCompleted = false;
    public defaultSortField = 'lastSavedDate';
    public searchTerm = new FormControl('');
    public searchSubscription: Subscription;
    public gridData: SamplesInfo[];
    public showSubmitAlert: Observable<boolean>;
    public displayDateFilter = false;
    public pagePerItems = [25, 50, 75, 100, 250, 500];
    public defaultPageSize = 25;

    constructor(
        private readonly urlBuilder: UrlBuilder,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private samplesService: SampleDetailsService,
        activityLogger: ActivityLogger
    ) {
        this.getPendingSamplesList();
        const searchTermFlow = merge(
            of(''),
            this.searchTerm.valueChanges
                .pipe(
                    debounceTime(300),
                    distinctUntilChanged()
                )
        );
        this.searchSubscription = searchTermFlow.subscribe((term) => {
            this.applySearch(term);
            this.changeDetectorRef.markForCheck();
        });
        activityLogger.logActivity('Pending Registration - List View');
    }

    public getPendingSamplesList() {
        this.isLoadingCompleted = false;
        this.samplesService.getPendingRegistrationList().subscribe((result: SamplesInfo[]) => {
            this.gridData = result;
            this.gridDetails = { header: this.samplesService.getPendingRegisterationHeader(), data: result };
            this.isLoadingCompleted = true;
            this.changeDetectorRef.markForCheck();
        });
    }

    public onQuickFilterChange() {

    }

    public registerSample() {
        this.urlBuilder.esa().sampleManagement().registerNewSample().navigate();
    }

    public onGridItemClick($event: any) {
        if ($event.header.actionType === ActionType.resume) {
            localStorage.setItem('resumeRegistration', $event.data.accessionNumber);
            this.urlBuilder.esa().sampleManagement().resumeRegistration().navigate();
        }
        if ($event.header.actionType === ActionType.delete) {
            this.deletePendingRegistration($event.data.accessionNumber, $event.data.registeredVisitId, true);
        }
    }

    public applySearch(term: string) {
        let header = this.samplesService.getPendingRegisterationHeader();
        if (!term || !term.length || !this.gridData.length) {
            this.gridDetails = { header: header, data: this.gridData };
        } else {
            let filterData = this.samplesService.applySearch(term, header, this.gridData);
            this.gridDetails = { header: header, data: filterData };
        }
        this.changeDetectorRef.markForCheck();
    }

    public onPagePerItemsChange($event: any) {
        this.defaultPageSize = $event.pageSize;
    }

    private async deletePendingRegistration(accessionNo: string, registedVisitId: number, isYesButtonClicked: boolean) {
        (await this.samplesService.OpenDeleteSampleRegistration(accessionNo, registedVisitId, isYesButtonClicked)).toPromise().then(result => {
            if (result) {
                this.getPendingSamplesList();
                this.changeDetectorRef.markForCheck();
            }
        });
    }
}
